import { useEffect, useState } from "react";
import DashboardApi from "../../../../../api/DashboardApi";
import { DeviceOverviewWrapper, DeviceTotalWrapper, DeviceOnlineWrapper, Icon,TextWrapper, Text } from "./DeviceOverview.styled";
import { PieChartTwoTone, CheckCircleTwoTone } from "@ant-design/icons";

interface DeviceOverviewProps {

}


const DeviceOverview : React.FC<DeviceOverviewProps> = (props) => {
    
     // api
    let dashboardApi = new DashboardApi();
   
    // state
    let [deviceTotal, setDeviceTotal] = useState(0);
    let [deviceOnline, setDeviceOnline] = useState(0);

 
    // onload
    useEffect(()=> {
        let loadSystemOverview = async ()=> {
            let systemRealtimeOverview = (await dashboardApi.getSystemRealtimeOverview()).data.data;
            setDeviceTotal(systemRealtimeOverview.deviceOverview.total);
            setDeviceOnline(systemRealtimeOverview.deviceOverview.online);
        };

        loadSystemOverview();

        let refreshTask = setInterval(()=> {
            loadSystemOverview();
        }, 5000);

        return () => {
            clearInterval(refreshTask);
        }
    }, []);

    return (
        <DeviceOverviewWrapper>
            <DeviceTotalWrapper>
                <Icon><PieChartTwoTone twoToneColor={['#b9b6b6', '#ecdaa8a6']} /></Icon>
                <TextWrapper>
                    <Text>设备总数 </Text>
                    <Text>{deviceTotal}</Text>
                </TextWrapper>
            </DeviceTotalWrapper>
            <DeviceOnlineWrapper>
                <Icon><CheckCircleTwoTone twoToneColor={['#79918d85', '#88e2f84b']}/></Icon>
                <TextWrapper>
                    <Text>在线设备 </Text>
                    <Text>{deviceOnline}</Text>
                </TextWrapper>
            </DeviceOnlineWrapper>
        </DeviceOverviewWrapper>
    );
}

export default DeviceOverview;